import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Services',
    href: '#services'
  }, {
    name: 'Our Work',
    href: '#work'
  }, {
    name: 'About',
    href: '#about'
  }, {
    name: 'Contact',
    href: '#contact'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md py-3' : 'bg-transparent py-4 lg:py-5'}`} data-id="element-95">
      <div className="container mx-auto px-6 max-w-7xl flex items-center justify-between" data-id="element-96">
        {/* Logo */}
        <a href="#" className={`font-heading font-bold text-2xl tracking-tight ${isScrolled ? 'text-brand' : 'text-white drop-shadow-md'}`} data-id="element-97">
          Cool Lawns
        </a>

        {/* Desktop Nav */}
        <nav className="hidden lg:flex items-center space-x-8" data-id="element-98">
          <ul className="flex space-x-8" data-id="element-99">
            {navLinks.map(link => <li key={link.name} data-id="element-100">
                <a href={link.href} className={`font-medium transition-colors hover:text-brand-light ${isScrolled ? 'text-gray-700' : 'text-white drop-shadow-sm'}`} data-id="element-101">
                  {link.name}
                </a>
              </li>)}
          </ul>
          <a href="#quote" className="bg-brand hover:bg-brand-light text-white font-semibold py-3 px-6 rounded-xl transition-colors min-h-[48px] flex items-center justify-center" data-id="element-102">
            Get a Free Quote
          </a>
        </nav>

        {/* Mobile Menu Toggle */}
        <button className={`lg:hidden p-2 -mr-2 min-h-[44px] min-w-[44px] flex items-center justify-center ${isScrolled ? 'text-gray-900' : 'text-white'}`} onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-103">
          {isMobileMenuOpen ? <X size={28} data-id="element-104" /> : <Menu size={28} data-id="element-105" />}
        </button>
      </div>

      {/* Mobile Nav Dropdown */}
      {isMobileMenuOpen && <div className="lg:hidden absolute top-full left-0 right-0 bg-white shadow-xl border-t border-gray-100 py-4 px-6 flex flex-col space-y-4" data-id="element-106">
          <ul className="flex flex-col space-y-4" data-id="element-107">
            {navLinks.map(link => <li key={link.name} data-id="element-108">
                <a href={link.href} className="block text-lg font-medium text-gray-800 hover:text-brand py-2" onClick={() => setIsMobileMenuOpen(false)} data-id="element-109">
                  {link.name}
                </a>
              </li>)}
          </ul>
          <a href="#quote" className="bg-brand hover:bg-brand-light text-white font-semibold py-4 px-6 rounded-xl transition-colors w-full text-center min-h-[48px] flex items-center justify-center mt-4" onClick={() => setIsMobileMenuOpen(false)} data-id="element-110">
            Get a Free Quote
          </a>
        </div>}
    </header>;
}